/**
 * Configuration object to initialize the marketing tab.
 */

export const UNITS_UNIT_OF_MEASURE_CODE = "unit_measure.units";

export namespace MarketingConfig {

    export interface Product {
        guid: string;
        name: string;
    }

    export interface MarketingCategory {
        categoryGuid: string;
        categoryName: string;
        totalEquipment: number;
        salesUnitOfMeasure: UnitOfMeasure;
        products: Product[];
    }

    export interface Container {
        title: Title;
        periods: Periods;
        timeChangeTitle: string;
        unitOfMeasureChangeTitle: string;
        startingDate: string;
        defaultUnitOfMeasureCode: string;
        unitOfMeasures: UnitOfMeasure[];
        assets: Assets;
        newLocationsText: string;
        locationsPerformanceTitle: string;
        locationsRanks: LocationsRanks;
        salesTitle: string;
        salesTotals: SalesTotals;
        salesAverages: SalesAverages;
        productSales: ProductSales;
        dayIntervalSales: DayIntervalSales;
        weekdaySalesTitle: string;
        monthSalesTitle: string;
        weekSalesTitle: string;
        weekDayDayIntervalSalesTitle: string;
        productSelectionsAveragesTitle: string;
        assetsAverageWeekTitle: string;
        assetsAverageMonthTitle: string;
        isDeprecatedCompany2: boolean;
    }

    export interface Title {
        title: string;
    }

    export interface UnitOfMeasure {
        code: string;
        symbol: string;
        name: string;
        ratio: number;
    }

    export interface Periods {
        week: string;
        month: string;
        quarter: string;
        semester: string;
        year: string;
        yearAgo: string;
        twoYearsAgo: string;
        rolling4Weeks: string;
        rollingQuarter: string;
        rollingSemester: string;
        rollingYear: string;
    }

    export interface Assets {
        title: string;
        locationsTitle: string;
        telemetriesTitle: string;
        selectionsTitle: string;
    }

    export interface InstallationsHistory {
        title: string;
        weekTitle: string;
        monthTitle: string;
        locationsTitle: string;
        selectionsTitle: string;
    }

    export interface LocationsRanks {
        title: string;
        bestLocationsTitle: string;
        bestLocationsSubtitle: string;
        worstLocationsTitle: string;
        worstLocationsSubtitle: string;
        codeTitle: string;
        descriptionTitle: string;
        commercialCompanyTitle: string;
        sellerTitle: string;
    }

    export interface ProductSales {
        title: string;
        bestProductTitle: string;
    }

    export interface DayIntervalSales {
        title: string;
        bestDayIntervalTitle: string;
    }

    export interface SalesTotals {
        title: string;
    }

    export interface SalesAverages {
        title: string;
        locationAverageTitle: string;
        selectionAverageTitle: string;
        equipmentAverageTitle: string;
    }

}
